export const DEBUG_STORAGE_KEY = 'mpn_log'
